/* global mpegts */
import React, {useRef,useState,useEffect} from "react"
import {useSelector} from "react-redux"
import Fullscreen from "../Live/Fullscreen.js"
import Button from "./Buttons/Button"
import VolumeButton from "./Buttons/VolumeButton"
import PiPButton from "./Buttons/PiPButton"
import {generateUrl, catchupUrlGenerator} from "../../other/generate-url"
import {getImageUrl} from "../../other/axios"
import {Loading} from '../../other/Player-github/style';

import "./Player.css"

import styled from "styled-components"

const PlayerDiv = styled.div`
    width: 100%;
    background: #000;
    padding: 0;
    border-radius: 0.4rem;
    height: 40vh;
    position: relative;
    overflow: hidden;
    user-select:none;
`

const VideoElement = styled.video`
    width: 100%;
    height: 100%;
    object-fit: contain;
    background: #000;
`

const ContainerButtons = styled.div`
    display: flex;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3em;
    background-color: rgba(43, 51, 63, 0.7);
    color: white;
    transition:  bottom .5s ease;
    z-index: 10;
`

const Spin = styled.div`
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 5;
    top: 0;
    left: 0;
    display:flex;
    justify-content:center;
    align-items:center;
    background: rgba(0,0,0,0.2);
`

let timeout = null;

const Player = () => {
  const ref = useRef();
  const videoRef = useRef();
  const mpegPlayerRef = useRef(null);

  const playingChannel = useSelector(state => state.playingCh);
  const [play, setPlay] = useState(false);
  const [volume, setVolume] = useState(100);
  const [pip, setPip] = useState(false);
  const [fullscreen, setFullscreen] = useState(false);

  const [hoverStyle, setHoverStyle] = useState({bottom:"-3rem"});
  const [showCursor, setShowCursor] = useState({cursor: ""})

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (ref.current) {
      const elem = ref.current;
      if (fullscreen) {
        if (elem.requestFullscreen) elem.requestFullscreen();
        else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen();
        else if (elem.msRequestFullscreen) elem.msRequestFullscreen();
        showOverlayTimer();
      } else {
        setShowCursor({cursor: ""})
        if (document.exitFullscreen) document.exitFullscreen().catch(() => { });
        else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      }
    }
  }, [fullscreen])

  useEffect(() => {
    if (!playingChannel || playingChannel.disabled || (!playingChannel.stream_id && !playingChannel.direct_source)) {
      setIsLoading(false);
      return;
    }

    setError(false);
    setIsLoading(true);

    if (mpegPlayerRef.current) {
        try {
            mpegPlayerRef.current.unload();
            mpegPlayerRef.current.detachMediaElement();
            mpegPlayerRef.current.destroy();
        } catch(e) {}
        mpegPlayerRef.current = null;
    }

    // URL DIRETA (Sempre HTTPS para evitar Mixed Content e sem Proxy para evitar 403 Forbidden)
    let streamUrl = playingChannel.direct_source || generateUrl("live", playingChannel.stream_id, "ts");
    
    // Força HTTPS
    streamUrl = streamUrl.replace("http://", "https://");

    if (playingChannel.timeshift) {
      streamUrl = catchupUrlGenerator(streamUrl, playingChannel.timeshift, playingChannel.duration);
    }

    if (typeof mpegts !== 'undefined' && mpegts.getFeatureList().mseLivePlayback) {
        const player = mpegts.createPlayer({
            type: 'mpegts',
            isLive: true,
            url: streamUrl
        }, {
            enableWorker: false,
            lazyLoad: false,
            autoCleanupSourceBuffer: true,
            stashInitialSize: 128
        });

        player.attachMediaElement(videoRef.current);
        player.load();
        
        const playPromise = player.play();
        if (playPromise !== undefined) {
            playPromise.then(() => {
                setPlay(true);
                setIsLoading(false);
            }).catch(err => {
                if (err.name !== "AbortError") {
                    console.warn("MpegTS fail, trying native source...");
                    videoRef.current.src = streamUrl;
                    videoRef.current.play().catch(() => {});
                }
            });
        }

        mpegPlayerRef.current = player;
    } else {
        videoRef.current.src = streamUrl;
        videoRef.current.play().catch(() => {});
    }

    return () => {
        if (mpegPlayerRef.current) {
            try {
                mpegPlayerRef.current.destroy();
            } catch(e) {}
            mpegPlayerRef.current = null;
        }
    };
  }, [playingChannel]);

  useEffect(() => { if (videoRef.current) videoRef.current.volume = volume / 100; }, [volume]);
  useEffect(() => { if (videoRef.current) { if (play) videoRef.current.play().catch(() => {}); else videoRef.current.pause(); } }, [play]);

  const showOverlay = (show) =>{
    setShowCursor({cursor: ""})
    setHoverStyle({ bottom: show ? "0rem" : "-3rem" })
  }

  const showOverlayTimer = () =>{
    setShowCursor({cursor: ""})
    clearTimeout(timeout);
    showOverlay(true);
    timeout = setTimeout(()=>{
      showOverlay(false);
      setShowCursor({cursor: "none"})
    },4000);
  }

    if (!playingChannel || playingChannel.disabled) return null;

    return (
      <PlayerDiv ref={ref} 
        onDoubleClick={() => setFullscreen(!fullscreen)} 
        onMouseEnter={()=> showOverlay(true)} 
        onMouseLeave = {()=> showOverlay(false)} 
        onMouseMove={() => (fullscreen || true) && showOverlayTimer()} 
        style={showCursor}>
        
        <VideoElement 
            ref={videoRef} 
            poster={getImageUrl(playingChannel.stream_icon)}
            playsInline
            onWaiting={() => setIsLoading(true)}
            onPlaying={() => setIsLoading(false)}
            onError={() => {}}
        />

        { isLoading === true && (<Spin>
            <Loading color={"var(--second-color);"}>
                <div><div /><div /><div /></div>
            </Loading>
        </Spin>)}

        {error === true && (
            <Spin>
                <div style={{textAlign:'center'}}>
                    <label style={{color:"white", display:'block'}}>Erro no canal.</label>
                    <button className="btn btn-sm btn-primary" onClick={() => window.location.reload()}>Recarregar</button>
                </div>
            </Spin>
        )}
        
        <Fullscreen externalShow={fullscreen && hoverStyle.bottom !== "-3rem"} cTitle={playingChannel.name} cDesc={playingChannel.category_name} cDuration={playingChannel.duration}/>
        
        <ContainerButtons dir="ltr" style={hoverStyle}>
          <Button enabled={play} onClick={() => setPlay(!play)} iconOn={"fas fa-pause"} iconOff={"fas fa-play"} textOn={"Pausar"} textOff={"Reproduzir"}/>
          <VolumeButton enabled={volume===0} onClick={() => setVolume(0)} onChangeInput={(e) => setVolume(e.target.value)} volume={volume}/>
          <PiPButton enabled={pip} onClick={() => setPip(!pip)}/>
          <Button enabled={fullscreen} onClick={() => setFullscreen(!fullscreen)} iconOn={"fas fa-compress"} iconOff={"fas fa-expand"} textOn={"Sair"} textOff={"Tela Cheia"}/>
        </ContainerButtons>
      </PlayerDiv>
    )
}

export default Player;
